import { useState } from 'react';
import { CheckIcon, CrossIcon } from 'assets/icons';
import passwordValidator from 'utils/passwordValidator';
import { PasswordInputProps } from 'Pages/Homepage/types';
import {
  InputStyled,
  PasswordErrorDialogWrap,
  PasswordErrorDialog,
  PasswordErrorDialogItem,
} from 'Pages/Homepage/styled';

export const PasswordInput = ({
  errorMsg,
  value,
  onChange,
  onBlur,
  onFocus,
  errors,
  defaultValue,
}: PasswordInputProps) => {
  const [isPasswordInputFocused, setPasswordInputFocused] = useState<boolean>(false);

  return (
    <>
      <InputStyled
        data-testid="passwordInput"
        id="password"
        type="password"
        placeholder="Password"
        onChange={onChange}
        value={value}
        error={errorMsg}
        onFocus={e => {
          setPasswordInputFocused(true);
          onFocus && onFocus(e);
        }}
        onBlur={e => {
          setPasswordInputFocused(false);
          onBlur && onBlur(e);
        }}
      />
      {isPasswordInputFocused &&
        passwordValidator(value)
          .map(rule => rule.valid)
          .filter(Boolean).length <= 2 && (
          <PasswordErrorDialogWrap data-testid="passwordErrorTooltip">
            <PasswordErrorDialog arrowPosition="top">
              <div>
                <p className="title" data-testid="passwordErrorTooltipTitle">
                  Must contain at least 3 of the following:
                </p>
                <ul>
                  {passwordValidator(value).map(({ id, label, valid }) => {
                    return (
                      <PasswordErrorDialogItem valid={valid} key={id}>
                        {valid ? (
                          <CheckIcon data-testid="passwordErrorTooltipCheck" className="checked" />
                        ) : (
                          <CrossIcon
                            color="var(--errorRed)"
                            data-testid="passwordErrorTooltipCross"
                          />
                        )}
                        <span>{label}</span>
                      </PasswordErrorDialogItem>
                    );
                  })}
                </ul>
              </div>
            </PasswordErrorDialog>
          </PasswordErrorDialogWrap>
        )}
    </>
  );
};
